const languageByDomainDetector = require('./languageByDomainDetector')
const ignoreRoutes = require('./ignoreRoutes')
const path = require('path')

module.exports = {
  ignoreRoutes,
  localePath: path.resolve('./public/static/locales'),
  defaultLanguage: 'en',
  fallbackLng: 'en',
  otherLanguages: ['nl', 'de', 'fr', 'hu', 'es', 'it', 'pt-BR'],
  load: 'currentOnly',
  customDetectors: [languageByDomainDetector],
  detection: {
    order: ['querystring', 'domain'],
    cookieSecure: true,
    cookieSameSite: 'strict',
  },
}
